import initService from "./init-service";
import sessionIdDirective from "../directive/sessionId-directive";
import Vue from "vue";

let baseurl = `${process.env.VUE_APP_CONFIG_ESIM_BASEURL}`;
let apikey = `${process.env.VUE_APP_CONFIG_APIKEY}`;
let userName = initService.getUserNameInfo();
let customer = initService.getCustomerInfo();
let group = initService.getGroupInfo();
let pId = sessionIdDirective.getJSessionId();
let headers = {
    headers: {
        "Content-Type": "application/json",
        "x-api-key": apikey,
    },
};

const EntitlementsService = {

    GetCarriers(carrier_name='') {
        if (typeof carrier_name==='undefined' || carrier_name==='undefined') carrier_name='';
        let method='ent_GetCarriers';
        let url = `${baseurl}?method=${method}&carrier_name=${carrier_name}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
        return Promise.resolve(Vue.axios.get(url, headers))
            .then(response => response.data.message)
            .catch(error => console.error(error));
    },

    GetInventory(iccid='', msisdn='', carrier_name='', page='') {
        if (typeof iccid==='undefined' || iccid==='undefined') iccid='';
        if (typeof msisdn==='undefined' || msisdn==='undefined') msisdn='';
        if (typeof carrier_name==='undefined' || carrier_name==='undefined') carrier_name='';
        if (typeof page==='undefined' || page==='undefined') page='';
        let method='ent_GetInventory';
        let url = `${baseurl}?method=${method}&iccid=${iccid}&msisdn=${msisdn}&carrier_name=${carrier_name}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
        return Promise.resolve(Vue.axios.get(url, headers))
            .then(response => response.data.message)
            .catch(error => console.error(error));
    },

    AddEntitlement(iccid, msisdn, imsi, carrier_name='', entitlements='VoWiFi,ap2004') {
        if (typeof iccid==='undefined' || iccid==='undefined') iccid='';
        if (typeof msisdn==='undefined' || msisdn==='undefined') msisdn='';
        if (typeof imsi==='undefined' || imsi==='undefined') imsi='';
        if (typeof carrier_name==='undefined' || carrier_name==='undefined') carrier_name='';
        if (typeof entitlements==='undefined' || entitlements==='undefined') entitlements='VoWiFi,ap2004';
        let method='ent_AddEntitlement';
        let url = `${baseurl}?method=${method}&iccid=${iccid}&msisdn=${msisdn}&imsi=${imsi}&carrier_name=${carrier_name}&entitlements=${entitlements}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
        return Promise.resolve(Vue.axios.get(url, headers))
            .then(response => response.data.message)
            .catch(error => console.error(error));
    },

    UpdateEntitlement(iccid, carrier_name='', entitlements = 'VoWiFi,ap2004') {
        if (typeof iccid==='undefined' || iccid==='undefined') iccid='';
        if (typeof carrier_name==='undefined' || carrier_name==='undefined') carrier_name='';
        if (typeof entitlements==='undefined' || entitlements==='undefined') entitlements='VoWiFi,ap2004';
        let method='ent_UpdateEntitlement';
        let url = `${baseurl}?method=${method}&iccid=${iccid}&carrier_name=${carrier_name}&entitlements=${entitlements}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
        return Promise.resolve(Vue.axios.get(url, headers))
            .then(response => response.data.message)
            .catch(error => console.error(error));
    },

    DeleteEntitlement(iccid, msisdn, carrier_name='') {
        if (typeof iccid==='undefined' || iccid==='undefined') iccid='';
        if (typeof msisdn==='undefined' || msisdn==='undefined') msisdn='';
        if (typeof carrier_name==='undefined' || carrier_name==='undefined') carrier_name='';
        let method='ent_DeleteEntitlement';
        let url = `${baseurl}?method=${method}&iccid=${iccid}&msisdn=${msisdn}&carrier_name=${carrier_name}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
        return Promise.resolve(Vue.axios.get(url, headers))
            .then(response => response.data.message)
            .catch(error => console.error(error));
    },

};

export default EntitlementsService;
